const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const pqrsService = {
  createPqr: async (pqrData) => {
    try {
      const response = await fetch(`${API_URL}/pqrs/create`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(pqrData),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al crear PQR');
      }
      return data;
    } catch (error) {
      console.error('Error al crear PQR:', error);
      throw error;
    }
  },

  fetchPqrs: async (filters = {}) => {
    try {
      const response = await fetch(`${API_URL}/pqrs/filter`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filters),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener PQRs');
      }
      return data;
    } catch (error) {
      console.error('Error al obtener PQRs:', error);
      throw error;
    }
  },

  fetchPqrById: async (id) => {
    try {
      const response = await fetch(`${API_URL}/pqrs/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener PQR');
      }
      return data;
    } catch (error) {
      console.error('Error al obtener PQR:', error);
      throw error;
    }
  },

  updatePqr: async (id, updateData) => {
    try {
      const response = await fetch(`${API_URL}/pqrs/update/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al actualizar PQR');
      }
      return data;
    } catch (error) {
      console.error('Error al actualizar PQR:', error);
      throw error;
    }
  },

  cerrarPqr: async (id, cerrarData) => {
    try {
      const response = await fetch(`${API_URL}/pqrs/cerrar/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cerrarData),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al cerrar PQR');
      }
      return data;
    } catch (error) {
      console.error('Error al cerrar PQR:', error);
      throw error;
    }
  },

  deletePqr: async (id) => {
    try {
      const response = await fetch(`${API_URL}/pqrs/delete/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al eliminar PQR');
      }
      return data;
    } catch (error) {
      console.error('Error al eliminar PQR:', error);
      throw error;
    }
  },

  getMetrics: async (filters = {}) => {
    try {
      const response = await fetch(`${API_URL}/pqrs/metrics`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(filters),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener métricas');
      }
      return data;
    } catch (error) {
      console.error('Error al obtener métricas:', error);
      throw error;
    }
  }
};

export default pqrsService;
